"use client";
import { trustpilotIntegrationEnabled } from "@config/site/site-config";
import type { IModuleHeadline, IPageHomepage } from "@contentful-api/types/contentful";
import { ModulesRenderer } from "@lib/contentful/modules-renderer/ModulesRenderer";
import { Box } from "@ui/components/layout/box/Box";
import dynamic from "next/dynamic";
import { useGlobalContent } from "@app/[locale]/GlobalContentProvider";
import { convertThemeNameFromContentfulToCamelCase } from "@lib/utils/theming/convertThemeNameFromContentfulToCamelCase";

const Headline = dynamic(() =>
    import("@components/cms/headline/Headline").then((mod) => mod.Headline)
);

const TrustpilotWidget = dynamic(() =>
    import("@components/commerce/reviews/trustpilot/TrustpilotReviews").then(
        (mod) => mod.TrustpilotWidget
    )
);

type HomePageProps = {
    page: IPageHomepage;
};

const HomePage = ({ page }: HomePageProps) => {
    const { fields: { modules, title, callToActions, desc } = {} } = page;
    const { siteSettings } = useGlobalContent();

    const { fields: { authorizationInvitation } = {} } = siteSettings;
    const theme = convertThemeNameFromContentfulToCamelCase(
        siteSettings?.fields?.promotionalThemeColor
    );

    return (
        <Box sx={{ mt: ["-67px", "-72px", "-82px", "-82px"] }} data-testid="Homepage">
            {desc && (
                <Headline
                    module={
                        {
                            fields: { title, desc, callToActions },
                        } as IModuleHeadline
                    }
                    isModule={false}
                />
            )}
            <main>
                <ModulesRenderer
                    modules={modules}
                    authorizationInvitation={authorizationInvitation}
                    theme={theme}
                />
                {trustpilotIntegrationEnabled && <TrustpilotWidget />}
            </main>
        </Box>
    );
};

export default HomePage;
